<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Section: Intro Text -->
  <div class="intro-section">
    <p class="intro-text">
      Grâce à de nombreux assureurs aussi bien <strong class="highlight-purple">Dommages, Santé que Prévoyance et Retraite</strong>, 
      il est possible de trouver une solution d'assurance qui vous corresponde en matière de prix et garanties.
    </p>
  </div>

  <!-- Section: Left - Simulations, Right - Contact Form -->
  <div class="main-content">
    <!-- Left Column: Simulations -->
    <div class="simulations-column">
      <h2 class="section-title">Obtenez votre simulation tout de suite !</h2>
      
      <div class="simulation-buttons">
        <!-- Assurance Mutuelle Santé Individuelle -->
        <button class="simulation-btn" routerLink="/devis-sante-particulier">
          <div class="btn-icon">
            <i class="pi pi-user"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Mutuelle Santé Individuelle</strong>
          </div>
        </button>

        <!-- Assurance Emprunteur -->
        <button class="simulation-btn" routerLink="/devis-emprunteur">
          <div class="btn-icon">
            <i class="pi pi-home"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Emprunteur</strong>.
          </div>
        </button>

        <!-- Assurance Mutuelle Santé Professionnelle -->
        <button class="simulation-btn" routerLink="/devis-sante-professionnelle">
          <div class="btn-icon">
            <i class="pi pi-briefcase"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Mutuelle Santé Professionnelle</strong>.
          </div>
        </button>

        <!-- Assurance Prévoyance GAV -->
        <button class="simulation-btn" routerLink="/devis-prevoyance-gav">
          <div class="btn-icon">
            <i class="pi pi-shield"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Prévoyance GAV</strong>.
          </div>
        </button>

        <!-- Assurance Prévoyance IJH -->
        <button class="simulation-btn" routerLink="/devis-prevoyance-ijh">
          <div class="btn-icon">
            <i class="pi pi-building"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Prévoyance IJH</strong>.
          </div>
        </button>

        <!-- Assurance Prévoyance Obsèques -->
        <button class="simulation-btn" routerLink="/devis-prevoyance-obseques">
          <div class="btn-icon">
            <i class="pi pi-heart"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Prévoyance Obsèques</strong>.
          </div>
        </button>

        <!-- Assurance Prévoyance Décès -->
        <button class="simulation-btn" routerLink="/devis-prevoyance-deces">
          <div class="btn-icon">
            <i class="pi pi-lock"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Prévoyance Décès</strong>.
          </div>
        </button>

        <!-- Assurance Chiens - Chats - Animaux -->
        <button class="simulation-btn" routerLink="/devis-animaux">
          <div class="btn-icon">
            <i class="pi pi-star"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance Chiens - Chats - Animaux</strong>.
          </div>
        </button>

        <!-- Assurance PNO -->
        <button class="simulation-btn" routerLink="/devis-pno">
          <div class="btn-icon">
            <i class="pi pi-building"></i>
          </div>
          <div class="btn-text">
            Cliquez ici pour un devis <strong>Assurance PNO</strong>.
          </div>
        </button>
      </div>

      <div class="contact-info">
        <h3>Vous avez des questions ?</h3>
        <p>
          Appelez-nous au <a href="tel:0143271243" class="phone-link">01 43 27 12 43</a> ou alors 
          <a href="/contact" class="rdv-link">prenez RDV</a> avec l'un de nos courtiers experts en assurance.
        </p>
      </div>
    </div>

    <!-- Right Column: Contact Form -->
    <div class="contact-column">
      <h2 class="section-title">Demandez-nous des devis</h2>
      
      <p class="form-intro">
        Notre équipe est en mesure de vous trouver l'assurance dont vous avez besoin pour couvrir le risque en question. 
        Un échange approfondi est nécessaire pour déterminer le besoin exact et voir quelle solution il vous faudra exactement. 
        N'hésitez pas, au choix de prendre directement un 
        <a href="/contact" class="inline-link">RDV Téléphonique en cliquant ici</a>, ou vous solliciter par téléphone 
        afin que l'on puisse en discuter. A très vite au <a href="tel:0143271243" class="inline-link">0143271243</a> ou 
        sur <a href="mailto:contact&#64;brokins.fr" class="inline-link">contact&#64;brokins.fr</a> ou sur 
        <a href="/contact" class="inline-link">RDV</a>.
      </p>

      <form class="devis-form" (ngSubmit)="submitForm()">
        <div class="form-row">
          <div class="form-group">
            <label>Nom complet <span class="required">*</span></label>
            <div class="name-inputs">
              <input 
                type="text" 
                placeholder="Prénom" 
                [(ngModel)]="contactForm.prenom"
                name="prenom"
                required>
              <input 
                type="text" 
                placeholder="Nom" 
                [(ngModel)]="contactForm.nom"
                name="nom"
                required>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Adresse e-mail <span class="required">*</span> <span class="confidential">(Politique de Confidentialité)</span></label>
          <input 
            type="email" 
            placeholder="ex: assure&#64;example.com" 
            [(ngModel)]="contactForm.email"
            name="email"
            required>
        </div>

        <div class="form-group">
          <label>Téléphone <span class="required">*</span> <span class="confidential">(Politique de Confidentialité)</span></label>
          <input 
            type="tel" 
            placeholder="00 00 00 00 00" 
            [(ngModel)]="contactForm.telephone"
            name="telephone"
            required>
          <small class="helper-text">Veuillez entrer un numéro de téléphone valide.</small>
        </div>

        <div class="form-group">
          <label>Message <span class="required">*</span></label>
          <textarea 
            rows="6" 
            placeholder="Écrivez ici..." 
            [(ngModel)]="contactForm.message"
            name="message"
            required></textarea>
        </div>

        <button type="submit" class="submit-btn">Envoyer</button>
        <button type="button" class="clear-btn">Effacer</button>
      </form>
    </div>
  </div>

</app-page-layout>
